import {GenericDgSearchResults} from "./generic.dg-search-results.model";
import {VisitLabTestData} from "../visit-lab-test-data.model";

export class VisitLabTestDataDgSearchResults extends GenericDgSearchResults {
  public results: VisitLabTestData[];

  constructor(total: number, results: VisitLabTestData[], csrfToken: string) {
    super();
    this.total = total;
    this.results = results;
    this.csrfToken = csrfToken;
  }
}
